import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function CottonCubsLogo({ size = 44 }) {
  const r = 44;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <circle cx="50" cy="50" r={r} fill="white" fillOpacity=".9"/>
      <circle cx="50" cy="50" r={r} stroke="#c9907a" strokeWidth="1.2" strokeDasharray="3.5 4.5" fill="none"/>
      <circle cx="50" cy="50" r="38" stroke="#c9907a" strokeWidth=".5" fill="none" opacity=".35"/>
      {[0,45,90,135,180,225,270,315].map(deg => {
        const x = 50 + r * Math.cos((deg-90)*Math.PI/180);
        const y = 50 + r * Math.sin((deg-90)*Math.PI/180);
        return <circle key={deg} cx={x} cy={y} r="1.6" fill="#c9907a" opacity=".6"/>;
      })}
      <text x="50" y="44" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#3d2416" fontStyle="italic" fontWeight="600">Cotton</text>
      <text x="50" y="58" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#3d2416" fontStyle="italic" fontWeight="600">Cubs</text>
      <text x="50" y="68" textAnchor="middle" fontFamily="Georgia,serif" fontSize="5" fill="#7a5040" letterSpacing="2.5" opacity=".7">ORGANIC CLOTHING</text>
    </svg>
  );
}

export default function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const success = await onLogin(password);
    setLoading(false);
    if (success) {
      navigate('/admin');
    } else {
      setError('Invalid password');
      setPassword('');
    }
  };

  return (
    <div style={{ fontFamily: "'Nunito',sans-serif", background: '#faf6f0', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;1,600&family=Nunito:wght@300;400;500;600;700;800;900&display=swap');`}</style>
      <div style={{ background: '#fff', borderRadius: 20, padding: '44px 36px', boxShadow: '0 8px 32px rgba(92,61,46,.12)', width: 380, maxWidth: '90vw' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <CottonCubsLogo size={56} />
          <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 700, color: '#3d2b1f', marginTop: 14, fontStyle: 'italic' }}>Admin Login</h1>
          <p style={{ fontSize: 14, color: '#7a5c4a', marginTop: 6 }}>Cotton Cubs Inventory Management</p>
        </div>
        <form onSubmit={handleSubmit}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 700, color: '#3d2b1f', marginBottom: 6 }}>Password</label>
          <input
            type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter admin password"
            style={{ width: '100%', padding: '12px 14px', border: '1.5px solid #ede3d5', borderRadius: 10, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box', transition: 'border-color .2s' }}
            onFocus={(e) => { e.target.style.borderColor = '#c0735a'; }}
            onBlur={(e) => { e.target.style.borderColor = '#ede3d5'; }}
            autoFocus
          />
          {error && <p style={{ color: '#dc3545', fontSize: 13, fontWeight: 700, marginTop: 8 }}>{error}</p>}
          <button type="submit" disabled={loading || !password}
            style={{ width: '100%', marginTop: 18, padding: '13px', background: '#c0735a', color: '#fff', border: 'none', borderRadius: 50, fontSize: 14, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', opacity: loading || !password ? 0.6 : 1 }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={{ textAlign: 'center', fontSize: 12, color: '#7a5c4a', marginTop: 20, opacity: 0.6 }}>Default: cottoncubs2025</p>
      </div>
    </div>
  );
}
